/**
 * Companion Page
 * VOY-12: AI Travel Companion with intelligent timeline
 */

import { NowCard } from '@/components/companion/now-card';
import { TimelineDayHeader } from '@/components/companion/timeline-day-header';
import { TimelineEvent } from '@/components/companion/timeline-event';
import { InsightsPanel } from '@/components/companion/insights-panel';
import { ChatInterface } from '@/components/companion/chat-interface';
import { 
  getTimelineEvents, 
  getAIInsights, 
  getChatHistory,
  getNowCardData 
} from '@/data/companion-timeline';

export default function CompanionPage() {
  const nowData = getNowCardData();
  const dayGroups = getTimelineEvents();
  const { suggestions, quickActions, reminders } = getAIInsights();
  const chatHistory = getChatHistory();

  const handleSendMessage = (message: string) => {
    console.log('[Companion] Message sent:', message);
    alert(`Demo: Message sent\n\n"${message}"\n\nIn a real app, this would send to AI and get a response.`);
  };

  return (
    <div className="min-h-screen bg-transparent">
      {/* Mobile Header */}
      <div className="md:hidden bg-white/80 dark:bg-zinc-900/80 backdrop-blur-md border-b border-gray-200/50 dark:border-zinc-700/50 px-4 py-3 shadow-sm">
        <div className="flex items-center justify-between text-xs text-gray-500 dark:text-zinc-400 mb-2">
          <span>9:41</span>
          <div className="flex items-center gap-1">
            <span>●●●</span>
          </div>
        </div>
        <h1 className="text-lg font-semibold bg-gradient-to-r from-[#5B6FED] to-[#8B9FED] bg-clip-text text-transparent">
          Your Travel Companion
        </h1>
        <p className="text-sm text-gray-600 dark:text-zinc-400">AI assistant tracking your journey</p>
      </div>

      {/* Main Content */}
      <div className="max-w-2xl mx-auto p-4 pb-32 space-y-5">
        {/* NOW Card - Sticky */}
        <NowCard {...nowData} />

        {/* AI Insights Panel */}
        <InsightsPanel
          suggestions={suggestions}
          quickActions={quickActions}
          reminders={reminders}
          defaultOpen={true}
        />

        {/* Timeline Events by Day */}
        {dayGroups.map((dayGroup) => (
          <div key={dayGroup.label}>
            {/* Day Header */}
            <TimelineDayHeader
              label={dayGroup.label}
              isToday={dayGroup.isToday}
              isTomorrow={dayGroup.isTomorrow}
            />

            {/* Events for this day */}
            <div className="space-y-4 mt-4">
              {dayGroup.events.map((event) => (
                <TimelineEvent key={event.id} event={event} />
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Chat Interface - Fixed Bottom */}
      <div className="fixed bottom-0 left-0 right-0 z-10">
        <ChatInterface
          recentQueries={chatHistory.filter(m => m.isUser).map(m => m.text)}
          onSendMessage={handleSendMessage}
        />
      </div>
    </div>
  );
}

